import Modal from 'react-modal';
import { getPermission, showMessageError } from '../../../classes/functions';
import { useState} from 'react';
import api from '../../../config.js';
import './cost.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaArrowRight, FaCog, FaHistory } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { FaRegSave } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '85%',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function AverageCost(){
  const [modalLog, setModalLog] = useState(false);
  const [carrying, setCarrying] = useState(true);
  const [warehouse, setWarehouse] = useState('');
  const [product, setProduct] = useState('');
  const [qtdePage, setQtdePage] = useState(500);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [currentOfList, setCurrentOfList] = useState({});
  const [listWarehouses, setListWarehouses] = useState([]);
  const [listLogSeparation, setListLogSeparation] = useState([]);
  const [averageCosts, setAverageCosts] = useState([]);

  function getAverageCost(){
    let params = `page=${page}&limit=${qtdePage}&product=${currentOfList?.id_product ? currentOfList?.id_product : ""}&warehouse=${currentOfList?.id_warehouse ? currentOfList?.id_warehouse : ""}`;

    api
    .get(`/api/average_cost?${params}`)
    .then((response) => {
      setAverageCosts(response.data.dados);
      setTotal(response.data.qtde);

      setCarrying(false);
    })
    .catch((error) => {
      setCarrying(false);

      console.log(error);
    });
  }

  function getWarehouses(){
    setCarrying(true);

    api
    .get("/api/warehouses/getList")
    .then((response) => {
      setListWarehouses(response.data);

      setCarrying(false);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  function postAverageCost(currentCost, currentOfList){
    setAverageCosts(averageCosts.map((averageCost) => {
      if(averageCost.ID === currentOfList.ID){
        averageCost.average_cost = currentCost;
      }

      return averageCost;
    }))

    let data = {
      id_product: currentOfList?.id_product,
      id_warehouse: currentOfList?.id_warehouse,
      cost: currentCost
    }
     
    api
    .post("/api/average_cost", data)
    .then((response) => {

    })
    .catch((error) => {
      console.log(error.response);
    });
  }
  
  async function viewLog(averageCostID) {
    api.get("/api/getLogAverageCost?id=" + averageCostID)
    .then((response) => {
      setListLogSeparation(response.data.list);
      setModalLog(true);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  } 

  function closeModal () {
    setModalLog(false);
  }

  useEffect(() => {
    getAverageCost();

    if(listWarehouses.length === 0){
      getWarehouses();
    }
  }, [page, qtdePage]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Custo Médio">
          <select className='selectQtdeItens' value={qtdePage} onChange={(e) => setQtdePage(e.target.value)}>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">
                  <div className="formDiv">
                    <select value={warehouse} onChange={(e) => setWarehouse(e.target.value)}>
                      <option value="">Todos</option>
                      {listWarehouses.map((item, index) => (
                        <option key={index} value={item.id}>{item.descricao}</option>
                      ))}
                    </select>
                  </div>
                </th>
                <th scope="col">
                  <div className="formDiv">
                    <input type="text" placeholder="Produto" value={product} onChange={(e) => setProduct(e.target.value)} maxLength="250"/>
                  </div>
                </th>
                <th scope="col">Quantidade</th>
                <th scope="col">Custo Médio</th>
                <th scope="col">Histórico</th>
              </tr>
            </thead>
            <tbody>
              {averageCosts.map((averageCost, index)=>{
                return(
                  <tr key={index}>
                    <td>{averageCost?.codigo_warehouse} - {averageCost?.warehouse}</td>
                    <td>{averageCost?.codigo_product} - {averageCost?.product}</td>
                    <td>{averageCost?.amount}</td>
                    <td>
                      <div className="average-cost__cost formDiv">
                        <input type="text" placeholder="Custo Médio" value={averageCost?.average_cost} onChange={(e) => postAverageCost(e.target.value, averageCost)}  onBlur={() => setCurrentOfList(averageCost)} disabled={!getPermission('CADASTROS - CUSTO MEDIO - EDICAO')}/>
                        <button>
                          <FaRegSave className="average-cost___icon" />
                        </button>
                      </div>                    
                    </td>
                    <td>
                      <Link className="action" onClick={() => viewLog(averageCost?.ID)}>
                        <FaHistory color="#000" size={17} />
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <br/>
        <div className="divGroupPagination">
            <button data-tip="Primeira página" onClick={() => setPage(1)} type="button" className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
            <button data-tip="Página anterior" onClick={() => setPage(page > 1 ? page - 1 : 1)} type="button" className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
              <center><label className="labelPage">Exibindo página {page} de {total}</label></center>
            </div>
            <button data-tip="Próxima página" onClick={() => setPage((page + 1) < total ? page + 1 : total)} type="button" className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" onClick={() => setPage(total)} type="button" className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
          </div>
      </div>}
      
      <Modal  
        isOpen={modalLog}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Log"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Usuário</th>
                  <th>Data</th>
                  <th>Hora</th>
                  <th>Armazém</th>
                  <th>Produto</th>
                  <th>Custo Médio</th>
                </tr>
              </thead>
              <tbody>
                {listLogSeparation && listLogSeparation.length && listLogSeparation.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td>
                        {index+1}
                      </td>
                      <td>{item.user}</td>
                      <td>{item.data}</td>
                      <td>{item.hora}</td>
                      <td>{item.dados.warehouse}</td>
                      <td>{item.dados.product}</td>
                      <td>{item.dados.custo_medio}</td>
                    </tr>
                )
              })}
              {listLogSeparation.length == 0 && 
                <tr>
                  <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>
              }
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}